export default __webpack_public_path__ + "static/media/close.icon.7b554e1d.svg";